"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashFlowRowIndexEnumArray = exports.CashFlowRowIndexEnum = void 0;
// Order of the root rows for the cash flow table
var CashFlowRowIndexEnum;
(function (CashFlowRowIndexEnum) {
    CashFlowRowIndexEnum[CashFlowRowIndexEnum["OPENING_BALANCE"] = 0] = "OPENING_BALANCE";
    CashFlowRowIndexEnum[CashFlowRowIndexEnum["TOTAL_INCOME"] = 1] = "TOTAL_INCOME";
    CashFlowRowIndexEnum[CashFlowRowIndexEnum["TOTAL_SPENDING"] = 2] = "TOTAL_SPENDING";
    CashFlowRowIndexEnum[CashFlowRowIndexEnum["CASHFLOW_CUMULATED"] = 3] = "CASHFLOW_CUMULATED";
    CashFlowRowIndexEnum[CashFlowRowIndexEnum["FINAL_BALANCE"] = 4] = "FINAL_BALANCE";
})(CashFlowRowIndexEnum || (exports.CashFlowRowIndexEnum = CashFlowRowIndexEnum = {}));
exports.cashFlowRowIndexEnumArray = Object.values(CashFlowRowIndexEnum);
